import {Theme, createStyles} from '@material-ui/core';

export const groupOnMobileStyles = (theme: Theme) =>
	createStyles({
		root: {
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				backgroundColor: theme.palette.common.white,
			},
		},
	});
